import React from 'react';

const GerProcesosPend2 = props => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  console.log('Resolución de la pantalla:', resolucionPantalla.ancho, resolucionPantalla.alto);
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*0.95

  return (
    <div>
      <iframe width={ancho} height={alto} src="https://lookerstudio.google.com/embed/reporting/0815fa35-c594-4290-b041-7272a940bb78/page/pzBgE"></iframe>
    </div>
  )
}
export default GerProcesosPend2